import React, { forwardRef } from 'react'
import { CheckboxContainer } from './checkbox-container'
import { CheckboxLabel } from './checkbox-label'

const Checkbox = forwardRef(({ checked, onChange }, ref) => {
  return (
    <input type="checkbox" checked={checked} onChange={onChange} ref={ref} />
  )
})

export { Checkbox, CheckboxContainer, CheckboxLabel }
